/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Header } from './header';
import { ItemContext, ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Labels } from './labels';
import { Table } from './table';
import type { EventReportData } from './types';

export function GoiasaEfficiencyVerification(props: {
  reportData: EventReportData;
}) {
  return (
    <ReportContext value={props.reportData}>
      <div style={{ breakAfter: 'page' }}>
        {props.reportData.body.items.map((item) => (
          <ItemContext value={item}>
            <div
              style={{
                height: '90%',
                width: '100vw',
                flex: 1,
                backgroundColor: 'white',
                fontFamily: 'sans-serif',
              }}
            >
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="Verificação de eficácia" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <InitialInfos />
                  <Table />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                }}
              >
                <Header sectionName="Análise de Acidentes" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Labels />
                </div>
              </div>
            </div>
          </ItemContext>
        ))}
      </div>
    </ReportContext>
  );
}
